import { BigNumber } from "ethers";

import Flexacoin from "../../modules/flexacoin";
import { useEntitySlices, useEntityTotals } from "../../modules/hooks";

const useGraphData = (col: string, id: string) => {
  const [entity, totalsLoading, totalsError] = useEntityTotals(col, id);
  const [values, loading, error] = useEntitySlices(col, id);

  if (totalsLoading || totalsError || loading || error) {
    return [null, false, true];
  }

  if (values.length === 0) {
    return [null, false, false];
  }

  const totalSupply = Flexacoin.toDecimal(
    entity?.totalSupply ?? BigNumber.from(0)
  ).toNumber();
  const totalReward = Flexacoin.toDecimal(
    entity?.totalReward ?? BigNumber.from(0)
  ).toNumber();

  // const data = values.reduceRight((arr, { supplyChange, rewardChange }, k) => {
  const data = values.reduceRight(
    (data, { supplyChange, rewardChange }, k) => {
      data.supply[k] =
        (k === values.length - 1 ? totalSupply : data.supply[k + 1]) -
        BigNumber.from(supplyChange).div(Flexacoin.decimalsFactor).toNumber();
      data.reward[k] =
        (k === values.length - 1 ? totalReward : data.reward[k + 1]) -
        BigNumber.from(rewardChange).div(Flexacoin.decimalsFactor).toNumber();
      return data;
    },
    { supply: [], reward: [] }
  );

  data.supply.push(totalSupply);
  data.reward.push(totalReward);

  return [data, true, false];
};

export default useGraphData;
